module.exports = __webpack_public_path__ + "5b6275a8fb6356b92d97c6a55dd7bd80.svg";